import type { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuthStore } from '@/features/auth/store/authStore';

export function OnboardingCompletionGuard({ children }: PropsWithChildren) {
  const location = useLocation();
  const user = useAuthStore((s) => s.user);

  if (user && !user.isSuperAdmin && !user.onboardingCompleted) {
    return <Navigate to="/onboarding/personal-details" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
